import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import deepMerge from 'deepmerge';

import DataTable from 'Components/DataTable';
import {
    DATA_TABLE_COLUMN_TYPE_AUTHOR,
    DATA_TABLE_COLUMN_TYPE_LINK,
    DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
    DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
    DATA_TABLE_COLUMN_TYPE_DATE,
    DATA_TABLE_COLUMN_TYPE_HIDDEN,
    DATA_TABLE_COLUMN_TYPE_STRING,
    ASSIGN_STATUS_COMPLETED,
} from 'Constants';

import { pageTitleDecorator } from 'Decorators';
import { QueryFilterType, SubmissionType, DataTableMetadataType } from 'Types';

import { load, updateFilter } from 'Actions/submission';

@connect(
    store => ({
        loading: store.submissionsList.loading,
        success: store.submissionsList.success,
        error: store.submissionsList.error,
        data: store.submissionsList.data,
        filter: store.submissionsList.filter,
        metadata: store.submissionsList.metadata,
    }),
    dispatch => ({
        load: filter => dispatch(load(filter)),
        updateFilter: filter => dispatch(updateFilter(filter)),
    })
)
@pageTitleDecorator('users.submissions')
export default class UserSubmissionsList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        error: PropTypes.bool.isRequired,
        data: PropTypes.arrayOf(SubmissionType),
        filter: QueryFilterType,
        metadata: DataTableMetadataType,
        load: PropTypes.func.isRequired,
        updateFilter: PropTypes.func.isRequired,
        match: PropTypes.object,
        id: PropTypes.number,
        isReviewer: PropTypes.bool
    };

    getFilter = () => {
        const { filter, match, id, isReviewer } = this.props;
        const userId = id ? id : match.params.id;
        let authFilter = {};

        if (isReviewer) {
            authFilter = { has: { reviewers: { where: { user_id: userId, status: ASSIGN_STATUS_COMPLETED } } }, order: 'id desc' };
        } else {
            authFilter = { where: { user_id: userId }, order: 'default desc' };
        }

        return deepMerge(authFilter, filter.merge({ where: { status_id: {} } }));
    };

    getColumns = () => {
        const { isReviewer } = this.props;

        return [
            {
                key: 'icon',
                col: { width: '3%' },
                title: 'data_table.empty',
                sortable: false,
                filterable: false,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
            },
            {
                key: 'id',
                col: { width: '3%' },
                title: 'data_table.id',
                sortable: true,
            },
            {
                key: 'title',
                col: { width: '25%' },
                title: 'data_table.title',
                sortable: true,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_STRING : DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: '/submissions/:id',
                    placeholders: {
                        id: item => item.realId,
                    },
                },
            },
            {
                key: 'authors',
                col: { width: '11%' },
                title: 'data_table.authors',
                sortable: false,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_AUTHOR,
            },
            {
                key: 'journal.title',
                col: { width: '20%' },
                title: 'data_table.journal_id',
                sortable: true,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_STRING : DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: '/journals/:id',
                    placeholders: {
                        id: item => item.journal_id,
                    },
                },
            },
            {
                key: 'status.status',
                col: { width: '9%' },
                title: 'data_table.status_id',
                sortable: true,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_STRING
            },
            {
                key: 'virtual_status',
                col: { width: '9%' },
                title: 'data_table.virtual_status',
                sortable: true,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
            },
            {
                key: 'created_at',
                col: { width: '10%' },
                title: 'data_table.submission_created_at',
                sortable: true,
                type: DATA_TABLE_COLUMN_TYPE_DATE,
            },
            {
                key: 'updated_at',
                col: { width: '10%' },
                title: 'data_table.submission_updated_at',
                sortable: true,
                type: isReviewer ? DATA_TABLE_COLUMN_TYPE_HIDDEN : DATA_TABLE_COLUMN_TYPE_DATE,
            },
        ];
    };

    render() {
        const { data, load, metadata, updateFilter } = this.props;

        return (
            <div>
                <DataTable
                    columns={this.getColumns()}
                    metadata={metadata}
                    data={data}
                    filter={this.getFilter()}
                    load={load}
                    updateFilter={updateFilter}
                    icon={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/UserEdit/containers/UserSubmissionsList.jsx